import 'scroll-behavior-polyfill';
import {} from 'jquery-ujs';
import './services/alert';
import './services/dropdown';
import './services/modal';
import './services/modal_content';

$(document).on('change', 'form[data-autosubmit]', e => {
  e.target.form.requestSubmit();
});
